import { FC, Fragment } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import AppBar from 'components/AppBar';
import SocialShare from 'components/SocialShare';
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import QuestionsList from './QuestionsList';
import PoweredBy from 'components/PoweredBy';
// i18next
import { useTranslation } from 'react-i18next';
import { selectResult } from 'store/player/playerSelectors';

const ResultsPage:FC = () => {
  const { t } = useTranslation('common');

  const quiz = useAppSelector(selectQuiz);
  const result = useAppSelector(selectResult);

  if (!result) return null;
  return (
    <Fragment>
      <PublicDevicePlayable />
      <div
        className="h-full flex flex-col p-4"
        style={{ background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') top / cover` : '' }}
      >
        <AppBar />
        <h2 className="pt-4 font-bold text-center text-white text-2xl">{t('common.results')}</h2>
        <div className="flex-1 overflow-y-auto">
          <QuestionsList />
        </div>
        <h3 className="text-center text-sm text-white font-bold my-2 px-4">{t('quiz.resultsPage.shareThisGame')}</h3>
        <SocialShare />
        <PoweredBy />
      </div>
    </Fragment>
  )
}

export default ResultsPage;
